<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Classifieds'" [buildings]="classifiedsService.buildings"></filter>
                </div>

                <classifieds-filter></classifieds-filter>

                <div class="col-sm-3">
                    <button type="button" class="btn btn-w-m btn-primary pull-right"
                            (click)="classifiedsService.isClassifiedsModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Classified
                    </button>
                </div>

            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allClassifieds'" [ngClass]="{'sk-loading': classifiedsService.spinnerShow}">
                    <classifieds-list></classifieds-list>
                </tab-item>
                <pagination *ngIf="classifiedsService.data.allClassifieds.total && urlService.queryParams['page']"
                            [total]="classifiedsService.data['allClassifieds'].total"></pagination>
                <spinner [spinnerShow]="classifiedsService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
    </div>
</div>

<classifieds-modal *ngIf="classifiedsService.isClassifiedsModalShow"></classifieds-modal>
<!--<sign-out-return-key-modal *ngIf="classifiedsService.returnKeyModal || keyLogService.signOutKeyModal"></sign-out-return-key-modal>-->
<!--<key-log-history *ngIf="classifiedsService.showHistoryModal"></key-log-history>-->



// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds.component.html